module.exports = __webpack_public_path__ + "assets/img/item4-bg.21a03447.png";